import React,{useState,useEffect} from 'react';
import StatCard from "../../common/StatCard";
import {useNavigate} from 'react-router-dom';
import surveyService from "../../../services/survey.service";
import Loading from '../../common/Loading';
// Main Survey List Page
function SurveyListPage() {
    //const surveys = useSurveyStore((state) => state.surveys);
    const [surveys,setSurveys] = useState([])
    const [filterStatus, setFilterStatus] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [loading,setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect (()=>{
        setLoading(true)
        surveyService.getClinicSurveyList(1)
            .then((res) => {
                console.log("✅ Survey Response:", res);
                if (Array.isArray(res)) {
                    setSurveys(res);
                } else if (res?.data && Array.isArray(res.data)) {
                    // if the response is wrapped in a data object
                    setSurveys(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
                console.error("❌ Error fetching surveys:", error);
            });

    },[]);

    const filteredSurveys = surveys.filter(survey => {
        const matchesStatus = filterStatus === 'all' || survey.status === filterStatus;
        const matchesSearch = survey.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            survey.description.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesStatus && matchesSearch;
    });
    const onPublishSurvey = () =>{
        navigate('/surveys/survey-publish');
    }
    const onEditSurvey = () =>{

    }

    const onViewData = () =>{

    }
    return (
        <div className="min-vh-100">
            <div className="container-fluid py-4 ">


                {/* Stats Cards */}

                {/* Quick Stats */}
                <div className="row mb-7">
                    <div className="col-6 col-lg-3">
                    <StatCard
                        title="Total Surveys"
                        value="24"
                        change="+3 Today"
                        icon="bi bi-file-earmark-text"
                        color="primary"

                    />
                    </div>
                    <div className="col-6 col-lg-3">
                    <StatCard
                        title="Published"
                        value="132"
                        change="Active"
                        icon="bi-megaphone-fill"
                        color="success"

                    />
                    </div>
                    <div className="col-6 col-lg-3">
                    <StatCard
                        title="Completed"
                        value="78"
                        change="This Month"
                        icon="bi-clipboard-check-fill"
                        color="info"

                    />
                    </div>
                    <div className="col-6 col-lg-3">
                    <StatCard
                        title="Draft"
                        value="5"
                        change="Running"
                        icon="bi-card-checklist"
                        color="danger"

                    />
                    </div>
                </div>
                {/* filter */}
                <div className="row mb-4">
                    <div className="col-md-3 col-sm-6 ms-auto">
                        <select
                            className="form-select"
                            value={filterStatus}
                            onChange={(e) => setFilterStatus(e.target.value)}
                        >
                            <option value="all">All Status</option>
                            <option value="published">Published</option>
                            <option value="completed">Completed</option>
                            <option value="draft">Draft</option>
                        </select>
                    </div>
                </div>
                {/* Surveys List */}
                <div className="row g-4">
                    {loading && <Loading/>}
                    {filteredSurveys.map(survey => (
                        <div key={survey.id} className="col-md-6 col-lg-4">
                            <div className="card border-0 shadow-sm h-100 hover-lift">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                    <span className={`badge ${survey.status === 'published' ? 'bg-success' : 'bg-warning'}`}>
                      {survey.status === 'published' ? (
                          <><i className="bi bi-check-circle me-1"></i>Published</>
                      ) : (
                          <><i className="bi bi-pencil me-1"></i>Draft</>
                      )}
                    </span>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-link text-muted p-0"
                                                data-bs-toggle="dropdown"
                                            >
                                                <i className="bi bi-three-dots-vertical"></i>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end">
                                                <li>
                                                    <a className="dropdown-item" href="#" onClick={() => onViewData(survey.id)}>
                                                        <i className="bi bi-eye me-2"></i>View Results
                                                    </a>
                                                </li>
                                                {survey.status === 'draft' && (
                                                    <li>
                                                        <a className="dropdown-item" href="#" onClick={() => onEditSurvey(survey.id)}>
                                                            <i className="bi bi-pencil me-2"></i>Edit
                                                        </a>
                                                    </li>
                                                )}
                                                <li>
                                                    <a className="dropdown-item" href="#">
                                                        <i className="bi bi-files me-2"></i>Duplicate
                                                    </a>
                                                </li>
                                                <li><hr className="dropdown-divider" /></li>
                                                <li>
                                                    <a className="dropdown-item text-danger" href="#">
                                                        <i className="bi bi-trash me-2"></i>Delete
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <h5 className="card-title fw-bold mb-2">{survey.title}</h5>
                                    <p className="card-text text-muted small mb-3">{survey.description}</p>

                                    <div className="d-flex align-items-center mb-3">
                                        <div className="me-3">
                                            <i className="bi bi-people text-muted me-1"></i>
                                            <span className="fw-semibold">{survey.responses}</span>
                                            <small className="text-muted ms-1">responses</small>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <small className="text-muted d-block">
                                            <i className="bi bi-calendar3 me-1"></i>
                                            Created: {new Date(survey.createdDate).toLocaleDateString()}
                                        </small>
                                        <small className="text-muted d-block">
                                            <i className="bi bi-clock-history me-1"></i>
                                            Modified: {new Date(survey.lastModified).toLocaleDateString()}
                                        </small>
                                    </div>

                                    <div className="d-grid gap-2">
                                        {survey.status === 'published' ? (
                                            <button
                                                className="btn btn-outline-primary"
                                                onClick={() => onViewData(survey.id)}
                                            >
                                                <i className="bi bi-bar-chart me-2"></i>View Results
                                            </button>
                                        ) : (
                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-primary flex-fill text-white"
                                                    onClick={() => onEditSurvey(survey.id)}
                                                >
                                                    <i className="bi bi-pencil me-2"></i>Continue Editing
                                                </button>
                                                <button
                                                    className="btn btn-success flex-fill text-white"
                                                    onClick={() => onPublishSurvey(survey.id)}
                                                >
                                                    <i className="bi bi-megaphone-fill me-2"></i>Publish
                                                </button>
                                            </div>

                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        .hover-lift {
          transition: transform 0.2s, box-shadow 0.2s;
        }
        .hover-lift:hover {
          transform: translateY(-4px);
          box-shadow: 0 0.5rem 1.5rem rgba(0,0,0,0.15) !important;
        }
      `}</style>
        </div>
    );
}

export default SurveyListPage;